export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Vyhráli jste!']
export const GAME_COPIED_MESSAGE = 'Hra zkopírována do schránky'
export const ABOUT_GAME_MESSAGE = 'O hře'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Nedostatek písmen'
export const WORD_NOT_FOUND_MESSAGE = 'Slovo nebylo nenalezeno ve slovníku'
export const HARD_MODE_ALERT_MESSAGE =
  'Obtížná hra může být povolena pouze na začátku!'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Slovo bylo ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Musíte použít slovo ${guess} na pozici ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Slovo musí obsahovat ${letter}`
export const ENTER_TEXT = 'Zadat'
export const DELETE_TEXT = 'Smazat'
export const STATISTICS_TITLE = 'Statistika'
export const GUESS_DISTRIBUTION_TEXT = 'Distribuce odhadů'
export const NEW_WORD_TEXT = 'Nové slovo za'
export const SHARE_TEXT = 'Sdílet'
export const TOTAL_TRIES_TEXT = 'Počet pokusů'
export const SUCCESS_RATE_TEXT = 'Úspěšnost'
export const CURRENT_STREAK_TEXT = 'Aktuální strike'
export const BEST_STREAK_TEXT = 'Nejlepší strike'
